import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PasswordFields, strong } from "@/components/ChangePassword";

const card = "max-w-md mx-auto my-20 bg-[#0F172A]/80 border border-slate-800 rounded-lg p-8 space-y-4";
const cls = "w-full h-11 rounded-md bg-slate-900 border border-slate-700 px-3 text-sm focus:outline-none focus:border-[#1074BA]";
const btn = "w-full h-11 rounded-md bg-[#1074BA] hover:bg-[#0D629E] text-white text-sm font-semibold disabled:opacity-50";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { setMsg((await api.post("/auth/forgot-password", { email })).data.message); } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className={card} data-testid="forgot-form">
      <h1 className="text-2xl font-bold">Forgot password?</h1>
      <p className="text-sm text-slate-400">Enter your account email and we'll send you a link to choose a new password. The link is valid for 30 minutes.</p>
      {msg ? <p className="text-sm text-[#03AB9E]" data-testid="forgot-sent">{msg}</p> : (
        <>
          <input type="email" required className={cls} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          <button disabled={busy} className={btn} data-testid="forgot-submit">{busy ? "Sending…" : "Send reset link"}</button>
        </>
      )}
      <Link to="/login" className="block text-center text-xs text-slate-400 hover:text-white">Back to sign in</Link>
    </form>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [f, setF] = useState({ next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: f.next });
      toast.success("Password updated. Please sign in with your new password.");
      nav("/login");
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  if (!token) return <div className={card}><p className="text-sm text-red-400" data-testid="reset-no-token">This reset link is incomplete. Please <Link to="/forgot-password" className="underline">request a new one</Link>.</p></div>;
  return (
    <form onSubmit={submit} className={card} data-testid="reset-form">
      <h1 className="text-2xl font-bold">Choose a new password</h1>
      <PasswordFields value={f} onChange={setF} />
      <button disabled={busy || !strong(f.next) || f.next !== f.confirm} className={btn} data-testid="reset-submit">{busy ? "Saving…" : "Save new password"}</button>
    </form>
  );
}
